import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import ClientSide from "./ClientSide";
import SliderGrid from "./SliderGrid";
import { jsx as _jsx } from "react/jsx-runtime";
var ClientSideSliderGrid = function ClientSideSliderGrid(sliderProps) {
  return /*#__PURE__*/_jsx(ClientSide, {
    children: /*#__PURE__*/_jsx(SliderGrid, _objectSpread({}, sliderProps))
  });
};
export default ClientSideSliderGrid;